import { Label } from '@lego/connect-components-react';
import type { MultiValue } from 'chakra-react-select';
import { useState } from 'react';
import Combobox, {
  type ComboboxSize,
  type DefaultOptionType,
} from './combobox';
import { useFilteredThemes } from './combobox-queries';

type ThemesComboboxProps = {
  selectedItems: DefaultOptionType[];
  onSelect: (items: MultiValue<DefaultOptionType>) => void;
  size?: ComboboxSize;
};

const ThemesCombobox = ({
  selectedItems,
  onSelect,
  size = 'medium',
}: ThemesComboboxProps) => {
  const [searchValue, setSearchValue] = useState('');
  const { data, isFetching } = useFilteredThemes(searchValue);
  return (
    <div>
      <Label>Themes</Label>
      <Combobox
        options={
          data?.map((item) => ({
            id: item.idAsString,
            label: item.name ?? 'N/A',
          })) || []
        }
        selectedItems={selectedItems}
        isLoading={isFetching}
        onSelect={(selectedItems) => onSelect(selectedItems)}
        inputValue={searchValue}
        onInputChange={(value: string) => setSearchValue(value)}
        placeholder="Start typing theme to search"
        size={size}
      />
    </div>
  );
};
export default ThemesCombobox;
